/**
 * @file Frontend API client — publicPageService.
 */

import publicAxiosClient from "../api/publicAxiosClient";
import { API_URLS } from "../constants/apiUrls";

/** Type definition — Public Page Section. */
export type PublicPageSection = {
  heading?: string;
  body: string;
};

/** Type definition — Public Page. */
export type PublicPage = {
  slug: string;
  title: string;
  // Preferred structured format (easy for admin UI later)
  sections?: PublicPageSection[];
  // Optional fallback format
  content?: string;
  updatedAt?: string;
};

type PublicPageResponse = {
  success: boolean;
  data?: PublicPage;
  message?: string;
};

/** Exported const — public Page Service. */
export const publicPageService = {
  getBySlug: async (slug: string): Promise<PublicPage | null> => {
    const res = await publicAxiosClient.get<PublicPageResponse>(
      API_URLS.PAGES.BY_SLUG(slug)
    );
    if (!res?.data?.success || !res?.data?.data) return null;
    return res.data.data;
  },
};

